'use strict';

require('../es6');
module.exports = require('sugar-core');